import { useQuery, QueryResult } from '@apollo/client';
// Api
import { GET_CB_SETTINGS } from 'api/cbSettings/queries';
// Types
import {
  GetCbSettings,
  GetCbSettingsVariables,
} from 'api/cbSettings/types/GetCbSettings';
import { CbSettingScope, CbSettingType } from 'api/graphql-global-types';

type UseGetCbSettingsOptions = {
  scope: CbSettingScope;
  agencyId?: string | null;
  type?: CbSettingType;
  skip?: boolean;
};

export const useGetCbSettings = ({
  scope,
  agencyId,
  type,
  skip = false,
}: UseGetCbSettingsOptions): QueryResult<
  GetCbSettings,
  GetCbSettingsVariables
> => {
  const isAgencyScopeMissingId = scope === CbSettingScope.Agency && !agencyId;

  return useQuery<GetCbSettings, GetCbSettingsVariables>(GET_CB_SETTINGS, {
    variables: {
      input: {
        scope,
        agencyId: agencyId || null,
        type: type || null,
      },
    },
    skip: skip || isAgencyScopeMissingId,
    fetchPolicy: 'cache-and-network',
  });
};
